function r(r){return!!r?.error}export{r as hasApiError};
